// extracted by mini-css-extract-plugin
export default {"header":"ex8gHE1DZZb1HOGJDT01","chatTitle":"lkgVFijdmq1ghr1nxTqY","title":"TGdppu8gAGrROp6PVoGP","leftAddon":"sTizODaVrj0TOi1HnKa7","rightAddon":"DNiAe6WlaEBq1C0_24Vw"};